import React, { Fragment, useRef, useState } from 'react';
import TitleServices from '../TitleServices/TitleServices';
import CardIconInfo from '../CardIconInfo/CardIconInfo';
import Input from '../Input/Input';
import TextArea from '../TextArea/TextArea';
import FontsDefault from '../../Assistant/DefaultStyle';
import emailjs from 'emailjs-com';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ContactSection() {
  const form = useRef();

  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true)

    emailjs
      .sendForm(
        'service_bd2e32y',
        'template_encwkaz',
        form.current,
        't5oWk2qKq8ov3qrX6'
      )
      .then(
        (result) => {
          console.log(result.text);
          setOpen(true);
          setSending(false)
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );


  };

  return (
    <Fragment>
      <div className='lg:w-6/12 md:w-full w-full'>
        <TitleServices
          showBtn={false}
          title='إبقى على تواصل معنا'
          description='تحدث مع فريقنا'
          secondDescription='نرحب بك في أي وقت'
        />

        <CardIconInfo
          description='البريد الالكتروني'
          secondDescription='gestep.co@gmail.com'
          AiOutlineMailIcon
        />

        <CardIconInfo
          description='اتصل بنا'
          secondDescription='566012888(970+)'
          AiOutlineWhatsAppIcon
        />
      </div>

      <div
        className={`lg:h-144 lg:w-4/12 w-full mt-8 p-4 rounded-lg border-1 shadow-md shadow-gray500`}
      >
        <form ref={form} onSubmit={sendEmail}>
          <div className={`${FontsDefault.textCenter} p-6`}>
            <h1 className={`${FontsDefault.text3xl} text-gray700`}>احجز موعد</h1>
            <p className={`text-lg text-gray500`}>
              نحن هنا لمساعدتك على مدار الساعة طوال أيام الأسبوع مع الخبراء
            </p>
          </div>

          <div className={`${FontsDefault.textCenter}`}>
            <Input placeholder='الاسم' type='text' nameInput='name' />
            <Input placeholder='الايميل' type='text' nameInput='email' />
            <Input
              placeholder='رقم الهاتف'
              type='text'
              nameInput='phoneNumber'
            />

            <TextArea placeholder='رسالتك' nameInput='message' />
          </div>
          <div className='justify-center flex mt-2 '>
            <button
              className={`bg-amber text-textColor md:text-lg text-sm rounded-3xl font-bold px-9 py-3 `}
            >
              {sending ? 'جاري الإرسال' : 'أرسل'}
            </button>
          </div>
        </form>

        <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            تم ارسال رسالتك بنجاح
          </Alert>
        </Snackbar>
      </div>
    </Fragment>
  );
}

export default ContactSection;
